import React from "react";
import LegalPage from "./LegalPage";
import { LEGAL } from "./legalData";

const Terminos = () => (
  <LegalPage title="Términos y Condiciones" lastUpdated={LEGAL.lastUpdated}>
    <h2>1. Objeto</h2>
    <p>
      Los presentes Términos y Condiciones regulan la contratación y el uso de la plataforma
      {" "}{LEGAL.nombreComercial} (el "Servicio"), titularidad de {LEGAL.razonSocial}. Al registrarte
      o utilizar el Servicio aceptas estos Términos, el Aviso Legal y la Política de Privacidad.
    </p>

    <h2>2. Registro y cuenta</h2>
    <p>
      El acceso al Servicio requiere la creación de una cuenta con datos veraces y actualizados. El
      usuario es responsable de la custodia de sus credenciales y de la actividad realizada desde su
      cuenta. El alta se realiza de forma asistida por {LEGAL.nombreComercial}.
    </p>

    <h2>3. Planes, prueba gratuita y pagos</h2>
    <ul>
      <li>
        <strong>Prueba gratuita:</strong> el Servicio puede ofrecerse con un periodo de prueba (por
        ejemplo, 30 días) sin pago inicial. Al finalizar la prueba, el uso continuado requiere la
        contratación de un plan de pago.
      </li>
      <li>
        <strong>Planes de suscripción:</strong> los planes y precios vigentes se muestran en el Sitio
        Web. La suscripción se factura de forma recurrente (mensual o anual) a través de nuestro
        proveedor de pagos (Stripe).
      </li>
      <li>
        <strong>Servicio de migración:</strong> la migración completa de datos desde otro software es
        un servicio adicional que puede facturarse de forma fraccionada, según lo acordado con el
        cliente, y se presta cuando el cliente decide continuar con el Servicio.
      </li>
      <li>
        <strong>Impuestos:</strong> los precios se indican sin perjuicio de los impuestos aplicables,
        que se añadirán cuando corresponda.
      </li>
    </ul>

    <h2>4. Obligaciones del usuario y uso aceptable</h2>
    <p>
      El usuario se compromete a utilizar el Servicio conforme a la ley y a estos Términos, y a no
      emplearlo para fines ilícitos. El usuario es responsable de la legalidad de los datos que
      introduce y de cumplir la normativa que le resulte aplicable en su actividad, incluida la
      protección de datos de sus socios.
    </p>

    <h2>5. Disponibilidad del Servicio</h2>
    <p>
      {LEGAL.razonSocial} realizará esfuerzos razonables para mantener el Servicio disponible, pero no
      garantiza su funcionamiento ininterrumpido. Podrán realizarse tareas de mantenimiento o
      actualizaciones que afecten temporalmente a la disponibilidad.
    </p>

    <h2>6. Limitación de responsabilidad</h2>
    <p>
      En la medida permitida por la ley, {LEGAL.razonSocial} no será responsable de los daños
      indirectos, la pérdida de datos imputable al usuario o el uso indebido del Servicio. Nada en
      estos Términos limita la responsabilidad que no pueda excluirse legalmente.
    </p>

    <h2>7. Duración y cancelación</h2>
    <p>
      La suscripción se mantiene vigente mientras no se cancele. El usuario puede cancelar su plan
      conforme a las condiciones del plan contratado; la cancelación surtirá efecto al final del
      periodo de facturación en curso, salvo indicación en contrario.
    </p>

    <h2>8. Modificaciones</h2>
    <p>
      {LEGAL.razonSocial} podrá modificar estos Términos y los precios, informando a los usuarios con
      antelación razonable a través del Servicio o por correo electrónico.
    </p>

    <h2>9. Ley aplicable y jurisdicción</h2>
    <p>
      Estos Términos se rigen por la legislación española. Cualquier controversia se someterá a los
      Juzgados y Tribunales que correspondan conforme a Derecho. Para cualquier consulta, escríbenos a
      {" "}{LEGAL.email}.
    </p>
  </LegalPage>
);

export default Terminos;
